module.exports = __webpack_public_path__ + "img/bingo_ball-18.05f57398.png";